<header class="flex vcenter">
  <button
    payee-icon-button
    class="logout-button"
    (click)="logout()"
  >
    <payee-icon name="logout-grey"></payee-icon>
  </button>
  <button
    payee-button
    color="grey-light"
    class="name-button"
    [matMenuTriggerFor]="userMenu"
  >
    {{ userName }}
  </button>
  <mat-menu #userMenu="matMenu">
    <button
      mat-menu-item
      (click)="manageMFA()"
    >
      {{ (has2FA ? "USER_PROFILE.DISABLE_2FA" : "USER_PROFILE.ENABLE_2FA") | translate }}
    </button>
  </mat-menu>
</header>

<main id="cases-container">
  <payee-cases
    [getCasesPath]="getCasesPath"
    [getDebtorsPath]="getDebtorsPath"
    [showInfo]="false"
    [stages]="stages"
    [allowDelete]="false"
    [allowEdit]="false"
    [additionalActions]="additionalActions"
    [searchClients]="searchClients"
    [resolveClient]="resolveClient"
  ></payee-cases>
</main>
